export const PREDEFINED_COUNTRY_CODES = {
  UA: '(99) 999-99-99',
  BY: '(99) 999-99-99',
  RU: '(999) 999-99-99',
  TR: '999 999 99 99',
  HR: '99 9999999'
} as const;
